
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-close",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 13.4L28.8.6c.8-.8 1.8-.8 2.6 0s.8 1.8 0 2.6L18.6 16l12.8 12.6c.8.8.8 1.8 0 2.6s-1.8.8-2.6 0L16 18.6 3.2 31.4c-.8.8-1.8.8-2.6 0s-.8-1.8 0-2.6l12.8-12.6L.8 3.4C0 2.6 0 1.6.8.8S2.6 0 3.4.8L16 13.4z"}})])
          )
        }
      }
    